// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__kwe6p","footer":"ModalUpdate_footer__3cPw2"};